import axios from "axios";
import { API_BASE } from "../../config/env";

export const FETCH_PAGINGAPPLICATIONNURSE_FULFILLED = "FETCH_PAGINGAPPLICATIONNURSE_FULFILLED";
export const FETCH_PAGINGAPPLICATIONNURSE_REJECTED = "FETCH_PAGINGAPPLICATIONNURSE_REJECTED";
export const FETCH_PAGINGAPPLICATIONNURSE_PENDING = "FETCH_PAGINGAPPLICATIONNURSE_PENDING";
export const RESET_PAGINGAPPLICATIONNURSE = "RESET_PAGINGAPPLICATIONNURSE";

export function pagingApplicationNurse(pageSize, pageNumber, status, searchText = "") {
    const token = localStorage.getItem("accessToken");

    return (dispatch) => {
        dispatch({
            type: "FETCH_PAGINGAPPLICATIONNURSE",
            payload: axios({
                method: "get",
                url: `${API_BASE}/api/v3/second-opinion/paging-application-nurse?pageSize=${pageSize}&pageNumber=${pageNumber}&status=${status}${searchText ? `&searchText=${searchText}` : ""}`,
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "multipart/form-data",
                    "ngrok-skip-browser-warning": "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function resetPagingApplicationNurse() {
    return (dispatch) => {
        dispatch({
            type: "RESET_PAGINGAPPLICATIONNURSE",
        });
    };
}